module.exports = __webpack_public_path__ + "static/media/998215.fa0e20d9.png";